import { CloseIcon, HamburgerIcon } from '@chakra-ui/icons';
import { Box, IconButton, type IconButtonProps } from '@chakra-ui/react';
import React from 'react';

interface ToggleButtonProps extends IconButtonProps {
  isOpen: boolean;
}

export const ToggleButton = (props: ToggleButtonProps) => {
  const { isOpen, ...iconButtonProps } = props;
  return (
    <IconButton
      variant="unstyled"
      display="inline-flex"
      icon={<ToggleIcon active={isOpen} />}
      {...iconButtonProps}
    />
  );
};

const ToggleIcon = (props: { active: boolean }) => {
  const { active } = props;
  return (
    <Box
      color="white"
      className="group"
      data-active={active ? '' : undefined}
      as="span"
      display="flex"
      w="48px"
      h="48px"
      pos="relative"
      aria-hidden
      pointerEvents="none"
      bg="rawSienna.500"
      borderRadius="full"
      alignItems="center"
      justifyContent='center'

    >
      {active ? (
        <CloseIcon h="16px" w="16px" />
      ) : (
        <HamburgerIcon h="20px" w="20px" />
      )}
    </Box>
  );
};
